/**
 * Fulfillment API Service
 * Migrated from klook-admin/web/service/fulfillment.js
 * Only includes APIs used by order-list page (26 functions)
 *
 * URL migration: fulfillmentsrv → merchantcountersrv
 * - "在用" APIs: replaced to merchantcountersrv
 * - "已废弃/不迁移" APIs: keep original fulfillmentsrv URL
 */
import request from './fulfillment-request';
const baseURL = '/v1/merchantcountersrv/fulfillment';
const getUrl = (path) => `${baseURL}${path}`;
// 订单列表
const getOrderList = async (params) => request({
    method: 'get',
    url: getUrl('/fulfillment_service/get_order_list'),
    params
});
// 包含用户分发点权限逻辑的获取分发点列表
const getAreaListForAccount = async () => request({
    method: 'get',
    url: getUrl('/fulfillment_service/get_region_account')
});
// 拉取实体票分类
const getCategory = () => request({
    method: 'get',
    url: getUrl('/fulfillment_service/get_physical_type')
});
// 获取history
const getHistory = (params) => request({
    method: 'get',
    url: getUrl('/fulfillment_service/get_order_history'),
    params
});
// 分发到其他地区（PRD 排除，不迁移，保留原 URL）
const assignOrder = (data) => request({
    method: 'post',
    url: '/v1/fulfillmentsrv/fulfillment/assign',
    data
});
// 请求重新上传
const requestReuploadOrder = (params) => request({
    method: 'get',
    url: getUrl('/fulfillment_service/request_reupload'),
    params
});
// 导出文件
const postFulfillmentExportFile = (data) => request({
    method: 'post',
    url: getUrl('/fulfillment_service/export_extra_info'),
    data,
    responseType: 'blob'
});
// 导出全部（sheet export）
const postFulfillmentExtrainfoSheetExport = (data) => request({
    method: 'post',
    url: getUrl('/fulfillment_service/export_sheet'),
    data,
    responseType: 'blob'
});
// 打印 order（已废弃，保留原 URL）
const printOrder = (data) => request({
    method: 'post',
    url: '/v1/fulfillmentsrv/fulfillment/print',
    data
});
// 打印 单个unit（已废弃，保留原 URL）
const printUnit = (params) => request({
    method: 'get',
    url: '/v1/fulfillmentsrv/fulfillment/print/unit',
    params
});
// 获取order打印状态（已废弃，保留原 URL）
const getOrderPrintStatus = (data) => request({
    method: 'post',
    url: '/v1/fulfillmentsrv/fulfillment/print/status',
    data
});
// 获取unit打印状态（已废弃，保留原 URL）
const getUnitPrintStatus = (data) => request({
    method: 'post',
    url: '/v1/fulfillmentsrv/fulfillment/print/status/unit',
    data
});
// 对打印order分类
const getPrintCount = (data) => request({
    method: 'post',
    url: getUrl('/fulfillment_service/print_statistical'),
    data
});
// 获取打印中的ID（已废弃，保留原 URL）
const getPrintingId = (params) => request({
    method: 'get',
    url: '/v1/fulfillmentsrv/fulfillment/print/query',
    params
});
// 取消打印 order（已废弃，保留原 URL）
const cancelPrintOrder = (data) => request({
    method: 'post',
    url: '/v1/fulfillmentsrv/fulfillment/print/delete',
    data
});
// 取消打印 unit（已废弃，保留原 URL）
const cancelPrintUnit = (params) => request({
    method: 'get',
    url: '/v1/fulfillmentsrv/fulfillment/print/delete/unit',
    params
});
// 本地打印获取order路径
const getPrintOrderFile = (data) => request({
    method: 'post',
    url: getUrl('/fulfillment_service/merge_pdf'),
    data,
    responseType: 'blob'
});
// 本地打印更改状态 - order
const changeOrderPrintStatus = (data) => request({
    method: 'post',
    url: getUrl('/fulfillment_service/update_order_print_status'),
    data
});
// 本地打印更改状态 - unit
const changeUnitPrintStatus = (params) => request({
    method: 'get',
    url: getUrl('/fulfillment_service/update_unit_print_status'),
    params
});
// 上传快递信息 / 邮寄
const uploadDeliveryInfo = (data) => request({
    method: 'post',
    url: getUrl('/fulfillment_service/save_logistics'),
    data
});
// 物流信息修改
const logisticsUpdate = (params) => request({
    method: 'get',
    url: getUrl('/fulfillment_service/logistics_update'),
    params
});
// 获取快递模板
const getExcelTemplate = (data) => request({
    method: 'post',
    url: getUrl('/fulfillment_service/download_logistics_template'),
    data,
    responseType: 'blob'
});
// regain order
const regainOrder = (params) => request({
    method: 'get',
    url: getUrl('/fulfillment_service/regain_order'),
    params
});
// regain unit
const regainUnit = (params) => request({
    method: 'get',
    url: getUrl('/fulfillment_service/regain_order'),
    params
});
// regain 实体卡
const regainPhysicalCard = (params) => request({
    method: 'get',
    url: getUrl('/fulfillment_service/regain_physical_card'),
    params
});
// 获取物流公司列表
const getPhysicalCouriers = () => request({
    method: 'get',
    url: getUrl('/fulfillment_service/get_physical_couriers')
});
export { getOrderList, getAreaListForAccount, getCategory, getHistory, assignOrder, requestReuploadOrder, postFulfillmentExportFile, postFulfillmentExtrainfoSheetExport, printOrder, printUnit, getOrderPrintStatus, getUnitPrintStatus, getPrintCount, getPrintingId, cancelPrintOrder, cancelPrintUnit, getPrintOrderFile, changeOrderPrintStatus, changeUnitPrintStatus, uploadDeliveryInfo, logisticsUpdate, getExcelTemplate, regainOrder, regainUnit, regainPhysicalCard, getPhysicalCouriers };
